var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46967 15.5304C5.76256 15.8233 6.23744 15.8233 6.53033 15.5304L11.3033 10.7575C11.5962 10.4646 11.5962 9.98969 11.3033 9.6968C11.0104 9.40391 10.5355 9.40391 10.2426 9.6968L6 13.9394L1.75736 9.6968C1.46447 9.40391 0.989593 9.40391 0.696699 9.6968C0.403806 9.98969 0.403806 10.4646 0.6967 10.7575L5.46967 15.5304ZM6 15L5.25 15L5.25 15.0001L6 15.0001L6.75 15.0001L6.75 15L6 15Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    fill: "white",
    transform: "translate(1.04907e-06 24) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.b3c10de239e05fdeab90b965b08151db.svg";
export { ForwardRef as ReactComponent };